import { styled } from 'styled-components';
import emptyStateBackgroundImage from './emptyStateBg.png';

export const Container = styled.div`
  --cardSize: 50%;

  // 2 cards or more
  &:has(li:nth-child(2)) {
    --cardSize: 100%;
  }

  // 3 cards or more
  &:has(li:nth-child(3)) {
    --cardSize: 368px;

    .carousel {
      mask-image: linear-gradient(90deg,
      rgba(0, 0, 0, 0) 0%,
      rgba(0, 0, 0, 1) 20%,
      rgba(0, 0, 0, 1) 80%,
      rgba(0, 0, 0, 0) 100%);
    }

    &.atStart .carousel {
      mask-image: linear-gradient(90deg,
      rgba(0, 0, 0, 1) 0%,
      rgba(0, 0, 0, 1) 20%,
      rgba(0, 0, 0, 1) 80%,
      rgba(0, 0, 0, 0) 100%);
    }

    &.atEnd .carousel {
      mask-image: linear-gradient(90deg,
      rgba(0, 0, 0, 0) 0%,
      rgba(0, 0, 0, 1) 20%,
      rgba(0, 0, 0, 1) 80%,
      rgba(0, 0, 0, 1) 100%);
    }

    li {
      align-items: stretch;
    }

    button[aria-label="Previous"], button[aria-label="Next"] {
      display: inline-flex;
    }
  }


  position: relative;

  .carousel {
    list-style-type: none;
    margin: 0;
    padding: 0;
    display: grid;
    grid-auto-flow: column;
    gap: 16px;

    overflow-x: auto;
    scroll-snap-type: x mandatory;
    width: 100%;


    @media (prefers-reduced-motion: no-preference) {
      scroll-behavior: smooth;
    }

    &::-webkit-scrollbar {
      display: none;
    }

    > li {
      scroll-snap-align: start;
    }
  }

  li{
    width: var(--cardSize);
  }

  button[aria-label="Previous"], button[aria-label="Next"]{
    display: none;
    position: absolute;
    z-index: 10;
  }

  button[aria-label="Previous"]{
    left: 0;
    top: 50%;
    transform: translateY(-50%);
  }

  button[aria-label="Next"]{
    right: 0;
    top: 50%;
    transform: translateY(-50%);
  }

  &.noOpportunities {
    --cardSize: 368px;
    height: 228px;
    width: calc(100% + var(--space-400));

    .carousel {
      height: 100%;
    }

    background-image: url(${emptyStateBackgroundImage});
    background-position: left 425px top 0;
    background-repeat: no-repeat;
    background-size: auto 100%;

    mask-image: linear-gradient(90deg,
    rgba(0, 0, 0, 1) 0%,
    rgba(0, 0, 0, 1) 80%,
    rgba(0, 0, 0, 0) 100%);
  }

`
